import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { BenefitMetadataExtensionInterface } from '../../../../extension/interface/benefit-metadata.extension.interface';

export class MobilityBenefitMetadataExtension extends BenefitMetadataExtensionInterface {
  benefitId: BenefitDTOBenefitEnum = BenefitDTOBenefitEnum.Mobility;
  get Icon(): React.ComponentType<SvgIconProps> {
    return DirectionsBusIcon;
  }
}
